/// <reference types="datatables.net" />

import { Component, OnInit } from "@angular/core";
import { DataTableDirective } from "angular-datatables";
import { OrderMenu } from "../../_models/orderMenu";
import { Subject } from "rxjs";
import { AfterViewInit, OnDestroy, ViewChild } from "@angular/core";
import { User } from "../../_models/user";
import { AccessSecurity } from "../../_models/accessSecurity";
import { Globals } from "../../_models/globals";
import { Router, ActivatedRoute } from "@angular/router";
import { ApiIntegration } from "../../_services/api.integration";
import { AlertService } from "../../_services/alert.service";
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from "@angular/common/http";
//import { LocalStorageService,SessionStorageService,LocalStorage,SessionStorage} from "angular-web-storage";
import { environment } from "../../../environments/environment";
import { saveAs } from "file-saver";
import { DatePipe } from "@angular/common";
import * as _ from "lodash";
import { ExcelServiceService } from "../../_models/excel-service.service";
import { OrderLine } from "../../_models/orderLine";

@Component({
  selector: "app-orders",
  templateUrl: "./orders.component.html",
  styleUrls: ["./orders.component.css"],
  providers: [DatePipe],
})
export class OrdersComponent implements OnInit {
  ordersMainMenu: OrderMenu[] = [
    {
      displayName: "All",
      tabClicked: "all",
      orderStatus: "ALL",
      additional: "N",
    },
    {
      displayName: "New",
      tabClicked: "submitted",
      orderStatus: "CREATED",
      additional: "N",
    },
    {
      displayName: "In Process",
      tabClicked: "InProcess",
      orderStatus: "IN_PROCESS",
      additional: "N",
    },
    {
      displayName: "Ready to Ship",
      tabClicked: "readyToShip",
      orderStatus: "READY_TO_SHIP",
      additional: "N",
    },
    {
      displayName: "In Transit",
      tabClicked: "shipped",
      orderStatus: "IN_TRANSIT",
      additional: "N",
    },
    {
      displayName: "Delivered",
      tabClicked: "Delivered",
      orderStatus: "DELIVERED",
      additional: "Y",
    },
    {
      displayName: "RTO (Return to Origin)",
      tabClicked: "RTO",
      orderStatus: "RETURN",
      additional: "Y",
    },
    {
      displayName: "Hold",
      tabClicked: "onHold",
      orderStatus: "ON_HOLD",
      additional: "Y",
    },
    {
      displayName: "Cancelled",
      tabClicked: "Cancelled",
      orderStatus: "CANCELLED",
      additional: "Y",
    },
  ];

  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  dtInstance: DataTables.Api;
  dtTrigger = new Subject();
  statusText1: string = "";
  userDrop2: any = "ALL";
  orderStatus: any = "ALL";
  tabClicked: any;
  orders: any;
  ohid: any;
  ord: any;
  returnReasons: any;
  reasonError: string;
  cancelError: string;
  orderLines: OrderLine[] = [];
  unHoldActivities: string = "N";
  loadingCompleted = false;
  totalCount = 0;
  masterSelected: boolean = false;
  checkedList = [];
  cancelReasons: string;
  loading = true;
  checkedList2 = [];
  checkedOrderIdList = [];
  checkedListView = [];
  cancelActivities: string = "N";
  holdActivities: string = "N";
  returnPopUp: string = "N";
  getOrderId: any;
  orderData: any;
  activityDetails: string;
  errorMessage: string = "";
  previousStatus = "";
  totalRecords: number;
  errorMessage2: string = "";
  toDayDateAndTime = new Date().toLocaleString();
  reason: string;
  size: string;
  sizeError: string;
  awb: any = {
    tracking_data: "",
    track_status: "",
    shipment_status: "",
    shipment_track: [],
    shipment_track_activities: [],
  };
  orderActionPopup: string = "N";
  selection: string = "";

  constructor(
    public accessSec: AccessSecurity,
    private datePipe: DatePipe,
    private excelService: ExcelServiceService,
    private alertService: AlertService,
    private http: HttpClient,
    private api: ApiIntegration,
    private router: Router,
    private route: ActivatedRoute,
    public user: User,
    public g: Globals
  ) {
    setInterval(() => {
      this.toDayDateAndTime = this.datePipe.transform(
        new Date(),
        "dd-MM-yyyy HH:mm:ss"
      );
    }, 1000);
    if (this.g.pageTab !== null && this.g.pageTab !== undefined) {
      this.tabClicked = this.g.pageTab;
      let index = this.ordersMainMenu.findIndex(
        (d) => d.tabClicked === this.g.pageTab
      );
      if (index > -1) {
        if (this.tabClicked !== "all") {
          this.getOrderCount(this.orderStatus);
        }
        for (let ol of this.ordersMainMenu) {
          if (ol.tabClicked === this.g.pageTab) {
            this.populateTabData(this.g.pageTab, ol.orderStatus);
            this.switchPosition(ol);
          }
        }
      } else {
        this.tabClicked = "all";
        this.populateTabData("all", "ALL");
      }
    } else {
      this.tabClicked = "all";
      this.populateTabData("all", "ALL");
    }
  }
  tabChange() {
    this.checkedList = [];
    this.g.loaderDisplay = "display";
  }

  openActionPopup(value) {
    this.selection = value;
    this.orderActionPopup = "Y";
  }

  openSelectionPopup() {
    if (this.selection == "markAsAnHold") {
      this.holdOrderPopUp(this.orders);
    } else if (this.selection == "cancelOrder") {
      this.cancelOrderPopUp(this.orders);
    } else if (this.selection == "unHoldOrder") {
      this.unHoldMultiOrders(this.orders);
    }
  }

  populate(orderChange) {
    this.api.getShipmentsByAdmin(orderChange, "1").subscribe(
      (data: any) => {
        this.g.loaderDisplay = "";
        this.orders = data.ordersData;
      },
      (err) => {
        this.g.loaderDisplay = "";
        this.alertService.error("Error", err);
      }
    );
  }

  exportToXLSX() {
    this.excelService.exportAsExcelFile(this.orders, "sample");
  }

  closepopUpRequest() {
    this.orderActionPopup = "N";
    this.cancelActivities = "N";
    this.holdActivities = "N";
    this.unHoldActivities = "N";
    this.returnPopUp = "N";
    this.checkedList.length = 0;
    this.populateTabData(this.tabClicked, this.orderStatus);
  }

  selectShip(sl) {
    if (!sl.isSelected) {
      this.masterSelected = false;
    }
    this.getCheckedShipList();
  }

  splice(i, id) {
    let index = this.orders.findIndex((d) => d.orderHeaderId === id);
    if (index > -1) {
      this.orders[index].isSelected = false;
    }
    this.checkedList2.splice(index, 1);
    this.checkedOrderIdList.splice(index, 1);
    this.checkedListView.splice(index, 1);
  }

  reassignShipment() {
    this.router.navigate(["/admin/reassignShipment/" + this.checkedList2[0]]);
  }

  getOrderCount(orderStatus) {
    this.g.loaderDisplay = "display";
    this.loading = true;
    this.api
      .getOrderConsignmentsByStatusForAccountOwner(
        orderStatus,
        "ORDER",
      )
      .subscribe(
        (data: any) => {
          this.g.loaderDisplay = "";
          if (data) {
            this.totalCount = data.noOfRecords;
            this.loading = false;
          }
        },
        (err) => {
          this.alertService.error("Error", err);
        }
      );
  }

  switchPosition(om) {
    let index = this.ordersMainMenu.indexOf(om);
    om.additional = "N";
    if (om.displayName !== this.ordersMainMenu[5].displayName) {
      this.ordersMainMenu[5].additional = "Y";
    }
    var tmp = 4;
    for (let o of this.ordersMainMenu) {
      if (tmp < (this.ordersMainMenu || []).length) {
        if (om.displayName !== this.ordersMainMenu[tmp].displayName) {
          this.ordersMainMenu[tmp].additional = "Y";
        }
        tmp = tmp + 1;
      }
    }
  }

  disableAction(status) {
    let disable = true;
    let checkedList = [];

    if (this.orders && this.orders.length) {
      for (var i = 0; i < this.orders.length; i++) {
        if (this.orders[i].isSelected) {
          checkedList.push(this.orders[i]);
        }
      }
    }

    if (checkedList.length == 1) {
      if (this.tabClicked === "submitted") {
        if (
          status === "processing order" &&
          checkedList[0].orderStatus === "CREATED"
        ) {
          disable = false;
        }
      }

      if (this.tabClicked === "InProcess") {
        if (
          status === "processing" &&
          (checkedList[0].orderStatus === "IN_PROCESS" ||
            checkedList[0].orderStatus === "SKIP_INVOICE" ||
            checkedList[0].orderStatus === "PRINT_INVOICE")
        ) {
          disable = false;
        }
        if (
          status === "submitted" &&
          checkedList[0].orderStatus == "SUBMITTED"
        ) {
          disable = false;
        }
        if (
          status === "labelGenerated" &&
          checkedList[0].orderStatus == "LABEL_GENERATED"
        ) {
          disable = false;
        }
      }

      if (this.tabClicked === "readyToShip") {
        if (
          status === "reassign shipment" &&
          checkedList[0].orderStatus === "READY_TO_SHIP"
        ) {
          disable = false;
        }
      }
    } else {
      disable = true;
    }
    return disable;
  }

  processingOrder(orders) {
    this.router.navigate(["/admin/orderProcessing/" + this.checkedList2[0]]);
  }

  syncOrders() {
    this.g.loaderDisplay = "display";
    this.api
      .toSyncNowAllSellerOrders(
        this.user.accountOwnerId,
        this.user.organizationId
      )
      .subscribe(
        (data: any) => {
          this.g.loaderDisplay = "";
          if (data["code"] == 200) {
            this.alertService.success("Orders", "Sync Successfully");
            this.getOrdersByStatus(this.orderStatus);
          }
        },
        (err) => {
          this.alertService.error("Error", err);
          this.g.loaderDisplay = "";
        }
      );
  }

  populateTabData(triggered, orderStatus) {
    this.tabClicked = triggered;
    this.orderStatus = orderStatus;
    if (!this.previousStatus) {
      this.getOrdersByStatus(orderStatus);
    } else {
      this.rerender();
    }
  }

  resetCheckedList() {
    this.masterSelected = false;
    this.checkedList2 = [];
    this.checkedList = [];
    this.checkedOrderIdList = [];
    this.checkedListView = [];
    this.errorMessage = "";
  }

  cancelOrderPopUp(orders) {
    let i = 0;
    let ohid;
    for (let order of orders) {
      if (order.isSelected) {
        i = i + 1;
        ohid = order.orderHeaderId;
      }
    }
    if (i === 1) {
      this.cancelActivities = "Y";
      this.getReasons();
    }
  }

  generateManifest(orderIds) {
    var headerInfo = new HttpHeaders();
    headerInfo = headerInfo.append("Content-Type", "application/json");
    headerInfo = headerInfo.append("Accept", "application/pdf");
    headerInfo = headerInfo.append(
      "Authorization",
      "Bearer " + localStorage.getItem("jwt")
    );

    this.http
      .post(
        environment.apiUrl + "api/generateManifestPdfForOrders",
        {
          accountOwnerId: this.user.accountOwnerId,
          headerIds: orderIds,
          organizationId: this.user.organizationId,
          size: "A4",
        },
        { responseType: "blob", headers: headerInfo }
      )
      .subscribe(
        (resp: any) => {
          this.g.loaderDisplay = "";
          var mediaType = "application/pdf";
          var blob = new Blob([resp], { type: mediaType });
          var filename =
            "shipment_manifest_A4_" + this.toDayDateAndTime + ".pdf";
          saveAs(blob, filename);
          this.alertService.success(
            "Success",
            "Manifest generated successfully"
          );
          this.populateTabData("InProcess", "IN_PROCESS");
        },
        (err) => {
          this.g.loaderDisplay = "";
          //console.log(err);
          this.alertService.error("Error", "Failed to generate Manifest");
        }
      );
  }

  generateShippingLabel(orders) {
    let i = 0;
    for (let order of orders) {
      if (order.isSelected) {
        i = i + 1;
        this.ohid = order;
      }
    }
    if (i === 1) {
      if ( this.ohid.channelShipLabelUrl != "") {
        this.navigateShippingUrl(orders);
      } else {
        this.printShipment();
      }
    } else {
      this.errorMessage =
        "Can not ship multiple orders at once. Please select one at a time";
    }
  }

  getOrdersByStatus(orderStatus) {
    this.dtOptions = {
      ordering: false,
      pagingType: "full_numbers",
      lengthMenu: [20, 50, 100, 200],
      pageLength: 20,
      language: {
        searchPlaceholder:
          "Search by Order # / Channel Order # / Phone Number / Email",
      },
      serverSide: true,
      ajax: (dataTablesParameters: any, callback) => {
        if (this.previousStatus !== this.orderStatus) {
          dataTablesParameters.start = 0;
          this.previousStatus = this.orderStatus;
        }
        let query: any = {
          orderStatus: this.orderStatus,
          orderType: "ORDER",
          page: dataTablesParameters.start
            ? dataTablesParameters.start / dataTablesParameters.length
            : dataTablesParameters.start,
          size: dataTablesParameters.length,
        };
        if (
          (dataTablesParameters.search || {}).value &&
          (dataTablesParameters.search || {}).value.trim() !== ""
        ) {
          query.searchString = dataTablesParameters.search.value.trim();
        }

        this.g.loaderDisplay = "display";
        var header1 = new HttpHeaders();
        header1 = header1.append("Content-Type", "application/json");
        header1 = header1.append("Accept", "application/json");
        header1 = header1.append(
          "Authorization",
          "Bearer " + localStorage.getItem("jwt")
        );
        this.http
          .get(environment.apiUrl + "api/getOrderConsignmentsByStatus", {
            params: query,
            headers: header1,
          })
          .subscribe(
            (resp: any) => {
              this.orders = resp.ordersData;
              this.g.loaderDisplay = "";
              this.loadingCompleted = true;
              if (this.orderStatus === "ALL" && !query.searchString) {
                this.totalCount = resp.noOfRecords;
              }
              this.totalRecords = resp.noOfOrders;
              callback({
                recordsTotal: resp.noOfOrders,
                recordsFiltered: resp.noOfOrders,
              });
            },
            (err) => {
              this.g.loaderDisplay = "";
              this.alertService.error("Error", err);
            }
          );
      },
    };
  }

  holdMultiOrders(orders) {
    for (let order of orders) {
      if (order.isSelected) {
        this.holdOrder(order);
      }
    }
  }

  unHoldMultiOrders(orders) {
    for (let order of orders) {
      if (order.isSelected) {
        this.unHoldOrder(order);
      }
    }
  }

  ngOnInit(): void { }

  ngAfterViewInit(): void {
    this.dtTrigger.next(true);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next(true);
    });
  }

  submitOrder() {
    this.router.navigate(["/admin/createOrders"]);
  }

  holdOrderPopUp(p) {
    if ((this.checkedList2 || []).length == 1) {
      this.holdMultiOrders(p);
    } else {
      this.holdMultiOrders(p);
    }
  }

  getCheckedShipList() {
    this.checkedList2 = [];
    this.checkedOrderIdList = [];
    this.checkedListView = [];
    for (var i = 0; i < (this.orders || []).length; i++) {
      if (this.orders[i].isSelected) {
        this.checkedList2.push(this.orders[i]["orderHeaderId"]);
        this.checkedOrderIdList.push(this.orders[i]["orderHeaderId"]);
        this.checkedListView.push(this.orders[i]);
      }
    }
  }

  cancelMultiOrders(orders) {
    for (let order of orders) {
      if (order.isSelected) {
        this.cancelOrder(order);
      }
    }
  }

  closePopUp() {
    this.cancelActivities = "N";
    this.activityDetails = "";
  }

  closePopUpHold() {
    this.holdActivities = "N";
    this.activityDetails = "";
  }

  closePopUpUnHold() {
    this.unHoldActivities = "N";
    this.activityDetails = "";
  }

  returnOrders(orders) {
    let i = 0;
    let ohid;
    for (let order of orders) {
      if (order.isSelected) {
        i = i + 1;
        ohid = order;
      }
    }
    if (i === 1) {
      this.returnOrderGet(ohid);
    }
  }

  returnOrderGet(p) {
    this.returnPopUp = "Y";
    this.getOrderId = p;
    this.reasonSettingsList();
    this.returnOrderGetData(p);
  }

  returnPopUpClose() {
    this.returnPopUp = "N";
    this.size = "";
    for (let r of this.returnReasons) {
      r.config = "";
    }
  }

  getReasons() {
    this.api
      .getValues("1", "ACCOUNT_OWNER",this.user.accountOwnerId || this.orders.accountOwnerId, "REASON")
      .subscribe(
        (data: any) => {
          this.cancelReasons = data.tripleSetConfigDTOS;
        },
        (err) => {
          console.log(err);
        }
      );
  }

  holdOrder(ord) {
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append("Content-Type", "application/json");
    header1 = header1.append("Accept", "application/json");
    header1 = header1.append(
      "Authorization",
      "Bearer " + localStorage.getItem("jwt")
    );
    this.http
      .post(
        environment.apiUrl + "api/updateOrderH&L",
        {
          orderHeaderId: ord.orderHeaderId, //this.route.snapshot.params['id'],
          orderStatus: "ON_HOLD",
          organizationId: 1,
          accountOwnerId: ord.accountOwnerId,
        },
        { headers: header1 }
      )
      .subscribe(
        (data) => {
          this.g.loaderDisplay = "";
          if (data["code"] == 200) {
            this.alertService.success("Order", "Hold Successfully");
            this.closepopUpRequest();
          }
        },
        (err) => {
          this.g.loaderDisplay = "";
          this.closepopUpRequest();
          this.alertService.error("Error", err);
        }
      );
  }

  cancelOrder(ord) {
    this.cancelError = "";
    if (!this.reason) {
      this.cancelError = "please select reason";
      return false;
    }
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append("Content-Type", "application/json");
    header1 = header1.append("Accept", "application/json");
    header1 = header1.append(
      "Authorization",
      "Bearer " + localStorage.getItem("jwt")
    );
    this.http
      .post(
        environment.apiUrl + "api/updateOrderH&L",
        {
          orderHeaderId: ord.orderHeaderId, //this.route.snapshot.params['id'],
          orderStatus: "CANCELLED",
          organizationId: 1,
          shippingOption: ord.shippingOption,
          accountOwnerId: ord.accountOwnerId,
        },
        { headers: header1 }
      )
      .subscribe(
        (data) => {
          this.g.loaderDisplay = "";
          if (data["code"] == 200) {
            this.alertService.success("Order", "Cancelled Successfully");
            this.closepopUpRequest();
          }
        },
        (err) => {
          this.g.loaderDisplay = "";
          this.closepopUpRequest();
          this.alertService.error("Error", err);
        }
      );
  }

  unHoldOrder(ord) {
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append("Content-Type", "application/json");
    header1 = header1.append("Accept", "application/json");
    header1 = header1.append(
      "Authorization",
      "Bearer " + localStorage.getItem("jwt")
    );
    this.http
      .post(
        environment.apiUrl + "api/updateOrderH&L",
        {
          orderHeaderId: ord.orderHeaderId, //this.route.snapshot.params['id'],
          orderStatus: "UN_HOLD",
          organizationId: 1,
          accountOwnerId: ord.accountOwnerId,
        },
        { headers: header1 }
      )
      .subscribe(
        (data) => {
          this.g.loaderDisplay = "";
          if (data["code"] == 200) {
            this.alertService.success("Order", "UnHold Successfully");
            this.closePopUpHold();
            this.closepopUpRequest();
          }
        },
        (err) => {
          this.g.loaderDisplay = "";
          this.closepopUpRequest();
          this.alertService.error("Error", err);
        }
      );
  }

  printShipment() {
    var header1 = new HttpHeaders();
    header1 = header1.append("Content-Type", "application/json");
    header1 = header1.append("Accept", "application/pdf");
    header1 = header1.append(
      "Authorization",
      "Bearer " + localStorage.getItem("jwt")
    );
    this.g.loaderDisplay = "display";
    this.http
      .post(
        environment.apiUrl + "api/generateShippingLabelPDF",
        {
          headerId: this.ohid.orderHeaderId,
          organizationId: this.user.organizationId,
          accountOwnerId: this.ohid.accountOwnerId,
          size: "Custom",
        },
        { responseType: "blob", headers: header1 }
      )
      .subscribe(
        (resp: any) => {
          console.log(resp);
          var mediaType = "application/pdf";
          var blob = new Blob([resp], { type: mediaType });
          var filename =
            "ib_" +
            this.ohid.orderHeaderId +
            "_shipping_label_" +
            "Custom" +
            "_" +
            this.toDayDateAndTime +
            ".pdf";
          saveAs(blob, filename);
          this.g.loaderDisplay = "";
          this.size = "";
          this.closepopUpRequest();
        },
        (err) => {
          this.g.loaderDisplay = "";
          this.alertService.error("Error", err);
          this.closepopUpRequest();
        }
      );
  }

  navigateShippingUrl(orders) {
    let i = 0;
    for (let order of orders) {
      if (order.isSelected) {
        i = i + 1;
        this.ohid = order;
      }
    }
    if (i == 1) {
        window.open(this.ohid.channelShipLabelUrl, "_blank");
    }
  }

  returnOrderGetData(ord) {
    this.api
      .getOrderDataById(ord.orderHeaderId, this.user.accountOwnerId, "1")
      .subscribe(
        (data: any) => {
          this.orderData = data;
          this.orderLines = _.cloneDeep(this.orderData.lines);
          this.orderLines.forEach((d) => {
            d["previousQuantity"] = d.quantity;
          });
          this.reasonSettingsList();
        },
        (err) => {
          this.alertService.error("Error", err);
        }
      );
  }

  reasonSettingsList() {
    this.api
      .getValues(
        "1",
        "ACCOUNT_OWNER",
        this.user.accountOwnerId || this.orders.accountOwnerId,
        "REASON"
      )
      .subscribe(
        (data: any) => {
          this.returnReasons = data.tripleSetConfigDTOS;
        },
        (err) => {
          this.alertService.error("Error", err);
        }
      );
  }

  submitReturnOrder() {
    this.reasonError = "";
    if (!this.reason) {
      this.reasonError = "please select reason";
      return false;
    }
    let orderLine = {
      orderLineId: 0,
      returnQuantity: 0,
    };
    let linesArray = [];
    for (let or of this.orderData.lines) {
      if (or.productName) {
        orderLine.orderLineId = or.orderLineId;
        orderLine.returnQuantity = or.quantity;
        linesArray.push(_.cloneDeep(orderLine));
      }
    }
    var header1 = new HttpHeaders();
    header1 = header1.append("Content-Type", "application/json");
    header1 = header1.append("Accept", "application/json");
    header1 = header1.append(
      "Authorization",
      "Bearer " + localStorage.getItem("jwt")
    );
    this.http
      .post(
        environment.apiUrl + "api/createReturns",
        {
          accountOwnerId: this.user.accountOwnerId,
          orderHeaderId: this.getOrderId.orderHeaderId,
          orderLines: linesArray,
          orderStatus: "RETURN",
          organizationId: this.user.organizationId,
          returnReason: this.reason,
        },
        { headers: header1 }
      )
      .subscribe(
        (data) => {
          this.g.loaderDisplay = "";
          if (data["code"] == 200) {
            this.alertService.success("Return", "Successfully");
            this.closepopUpRequest();
          } else {
            this.alertService.error("Error", data["message"]);
            this.closepopUpRequest();
          }
        },
        (err) => {
          this.g.loaderDisplay = "";
          this.alertService.error("Error", err);
        }
      );
  }
}
